__webpack_require__.p = "https://qcmmedia.com/wp-content/themes/qcm-wp-2022/build/";